(($, Drupal) => {
  Drupal.behaviors.map = {
    attach: function attach() {

      $(".map__wrapper").once("map-wrapper").each(function () {
        const markerIconPath = "https://www.habermann-aurum-pumpen.de/themes/custom/brander/html/public/assets/images/svg/mapMarker.svg";
        const mapWrapper = $(this);
        const mapData = mapWrapper.data("map");
        const popups = mapWrapper.find(".map__popup");
        let popupOpened = false;

        const map = mapInit(".map__inner", 3, {"lat": 0, "lng": 0})
        const bounds = new google.maps.LatLngBounds();
        const coordinates = getCoordinates(mapData);
        const locationTexts = getLocationTexts(mapData);
        const locationId = getIds(mapData);

        const markers = createMarkers(map, coordinates, markerIconPath, bounds, locationTexts, locationId);
        const infoWindows = createPopups(markers, "map__popup-attached");

        const categoryDual = $(".category-dual__wrapper .categories__input");
        categoryDual.each(function () {
          if ($(this).prop("checked")) {
            const input = $(this);
            markers.forEach((element, index) => {
              element.setOptions({'opacity': .4})
              if (element.id == input.prop("id")) {
                setTimeout(delay, 1000);

                function delay() {
                  new google.maps.event.trigger(element, 'click');
                  infoWindows.forEach((element, index) => {
                    if (element)
                      element.close();
                  })
                }
              }
            })
          }
          $(this).on("click", function () {
            const clickInput = $(this);
            markers.forEach((element, index) => {
              element.setOptions({'opacity': .4})
              if (element.id == clickInput.prop("id")) {
                new google.maps.event.trigger(element, 'click');
                infoWindows.forEach((element, index) => {
                  if (element)
                    element.close();
                })
              }
            })
          })
        })

        markers.forEach((element, index) => {
          if (element.id == getHashState('location')) {
            setTimeout(delay, 1000);

            function delay() {
              new google.maps.event.trigger(element, 'click');
            }
          }

          element.setOptions({'opacity': .4})
          google.maps.event.addListener(element, "click", () => {
            element.setOptions({'opacity': 1})
            map.setZoom(8);
            if (element.locationText) {
              map.panTo(element.position);
            } else {
              openPopup(popups, mapData, index);
              map.panTo({"lat": coordinates[index].lat - .4, "lng": coordinates[index].lng});
            }
          });
        });
        mapFitToBounds(map, bounds);

        popups.on("click", function (e) {
          e.stopPropagation();
        })

        let popupCounter = 0;
        $(window).on("click", function () {
          if (popupOpened)
            popupCounter++;
          if (popupCounter == 2) {
            markers.forEach((element, index) => {
              element.setOptions({'opacity': .4})
            })
            infoWindows.forEach((element, index) => {
              if (element)
                element.close();
            })
            popups.removeClass("active");
            popupCounter = 0;
            popupOpened = false;
          }
        })

        function openPopup(popups, mapData, index) {
          popups.removeClass("active");
          popupOpened = true;

          $("#" + mapData[index]["popupId"]).addClass("active");
        }
      });
    }
  };

})(jQuery, Drupal);
